export default "__VITE_ASSET__BHmo1evV__"